import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { IconInfo } from '@xingternal/icons';
import { BodyCopy } from '@xingternal/typography';

import styles from './PageCreatedBanner.css';

const PageCreatedBanner = () => (
  <div className={styles.infoContainer} data-testid="PAGE_CREATED_BANNER">
    <IconInfo height={24} width={24} />
    <BodyCopy small className={styles.text}>
      <FormattedMessage id="EP_NEW_PAGE_CREATED_DRAFT" />
    </BodyCopy>
  </div>
);

export default injectIntl(PageCreatedBanner);
